import React, { useState } from "react";
import { Sparkles, Mail } from "lucide-react";
import { toast } from "sonner";
import api from "../api";

export const NewsletterSignup = () => {
  const [first, setFirst] = useState("");
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) { toast.error("Merci de cocher la case de consentement."); return; }
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { first_name: first, email, consent });
      setDone(true);
      toast.success("Inscription confirmée ✨");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Une erreur est survenue.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="container-x py-14 sm:py-20">
      <div
        className="relative overflow-hidden rounded-3xl border border-[#D4AF37]/30 p-7 sm:p-12"
        style={{ background: "linear-gradient(158deg, rgba(74,24,55,0.96), rgba(27,8,45,0.96))", boxShadow: "0 24px 70px rgba(0,0,0,0.5)" }}
        data-testid="newsletter-block"
      >
        <div className="absolute -right-4 -top-4 sm:-right-6 sm:-top-6 text-[#D4AF37]/12 pointer-events-none">
          <Sparkles size={56} strokeWidth={1} className="sm:hidden" />
          <Sparkles size={110} strokeWidth={1} className="hidden sm:block" />
        </div>
        <div className="relative max-w-xl">
          <div className="eyebrow mb-3 flex items-center gap-2 text-[#DFC07B]">
            <Mail size={14} /> Newsletter gratuite
          </div>
          <h2 className="font-serif text-2xl sm:text-3xl text-[#F9F5EE]">Le Tirage de la Semaine ✨</h2>
          <p className="mt-3 text-sm sm:text-base text-[#CBB9CF] leading-relaxed">
            Chaque semaine, reçois par email mon tirage intuitif de la semaine : l'énergie du moment,
            ce qui mérite ton attention et le message qui ressort des cartes.
          </p>

          {done ? (
            <div className="mt-6 rounded-2xl bg-[#D4AF37]/12 p-5 text-[#F9F5EE]" data-testid="newsletter-success">
              Merci ✨ Ton inscription est bien prise en compte. À très vite pour Le Tirage de la Semaine.
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="newsletter-form">
              <div className="grid sm:grid-cols-2 gap-3">
                <div>
                  <label className="field-label text-[#E7DCEA]">Prénom</label>
                  <input required className="field-input" value={first} onChange={(e) => setFirst(e.target.value)} data-testid="newsletter-first" />
                </div>
                <div>
                  <label className="field-label text-[#E7DCEA]">Email</label>
                  <input required type="email" className="field-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="newsletter-email" />
                </div>
              </div>
              <label className="flex items-start gap-3 text-sm text-[#E7DCEA] cursor-pointer">
                <input type="checkbox" className="w-4 h-4 mt-0.5 accent-[#D4AF37] shrink-0" checked={consent} onChange={(e) => setConsent(e.target.checked)} data-testid="newsletter-consent" />
                <span>J'accepte de recevoir Le Tirage de la Semaine et les actualités de La Maison de ta Sorcière Préférée.</span>
              </label>
              <button type="submit" disabled={loading} className="btn-primary" data-testid="newsletter-submit">
                {loading ? "Inscription…" : "Je reçois mon tirage ✨"}
              </button>
              <p className="text-xs text-[#B5A4BA] leading-relaxed">
                En t'inscrivant, tu acceptes de recevoir Le Tirage de la Semaine et les actualités de
                La Maison de ta Sorcière Préférée. Tu peux te désinscrire à tout moment.
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default NewsletterSignup;
